
import Vue from "vue";
import { BRow, BCol } from "bootstrap-vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
@Component({
  components: {
    BRow,
    BCol,
  },
})
export default class CardTicket extends Vue {
  @Prop() title!: string;
  @Prop() message!: string;
  @Prop() date!: string;
  @Prop() ago!: string;
  @Prop() time!: string;
  @Prop() isOpen!: string;
  @Prop() pageClose!: boolean;

  setAsRead() {
    this.$emit("set-as-read");
  }
}
